import {Component, ViewChild} from "@angular/core";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {SellableSearchPageComponent} from "../sellable-search-page/sellable-search-page.component";

export class SellableReportSelectionData extends EntityData<SellableReportSelectionData> {
    @identifier sellableId: number;
    @field name: string;
    @field price: number;
    @field categoryName: string;
}

@Component({
    selector: "wbo-sellable-report-selection",
    templateUrl: "./sellable-report-selection-control.component.html"
})
export class SellableReportSelectionControlComponent {

    SellableSearchPageComponent = SellableSearchPageComponent;

    fieldName: string = "sellables";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromSellable(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((sellable: any) => sellable.sellableId === item.sellableId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
